import { OnInit, Component } from '@angular/core';


@Component({
  selector: 'app-info-user',
  template: `
  `,
  styles: []
})

export class UsersInformationComponent implements OnInit {
  constructor() {

  }

  ngOnInit() {

  }
}
